import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SUFFIX = "Vigyaved Healthcare";

// Exact-path titles; falls back to prefix matching below.
const MAP = {
  "/": `Vigyaved Healthcare — Predictive & Precision Medicine`,
  "/about": "About — Vigyaved Healthcare",
  "/healthcare": "Healthcare — Vigyaved Healthcare",
  "/research": "Research — Vigyaved Healthcare",
  "/innovation": "Innovation — Vigyaved Healthcare",
  "/publications": "Publications — Vigyaved Healthcare",
  "/founder": "Founder — Vigyaved Healthcare",
  "/investigators": "Investigators — Vigyaved Healthcare",
  "/collaborations": "Collaborations — Vigyaved Healthcare",
  "/contact": "Contact Us — Vigyaved Healthcare",
  "/login": "Sign in — Vigyaved Healthcare",
  "/reset-password": "Reset password — Vigyaved Healthcare",
  "/member": "Member Area — Vigyaved Healthcare",
  "/member/athena": "ATHENA — NICE by Vigyaved",
  "/member/advisor": "AI Health Advisor — ATHENA by Vigyaved",
  "/membership": "ATHENA Membership & Pricing — Vigyaved",
  "/pricing": "Pricing — Vigyaved Healthcare",
  "/privacy": "Privacy Policy — Vigyaved Healthcare",
  "/terms": "Terms & Conditions — Vigyaved Healthcare",
  "/refund-policy": "Cancellation & Refund Policy — Vigyaved Healthcare",
  "/payment/success": "Payment — Vigyaved Healthcare",
  "/payment/cancel": "Payment — Vigyaved Healthcare",
  "/nice": "NICE — Nexoria Institute of Cardiometabolic Excellence",
  "/nice/about": "About NICE — by Vigyaved",
  "/nice/cardiometabolic": "Cardiometabolic Intelligence — NICE by Vigyaved",
  "/nice/precision-health": "Precision Health — NICE by Vigyaved",
  "/nice/ai": "AI in Medicine — NICE by Vigyaved",
  "/nice/athena": "ATHENA — NICE by Vigyaved",
  "/nice/environmental": "Environmental Health — NICE by Vigyaved",
  "/nice/aging": "Aging & Longevity — NICE by Vigyaved",
  "/nice/research-programs": "Research Programs — NICE by Vigyaved",
  "/nice/clinical-research": "Clinical Research — NICE by Vigyaved",
  "/nice/education": "Education — NICE by Vigyaved",
  "/nice/network": "Network — NICE by Vigyaved",
  "/nice/webapps": "WebApps by Vigyaved — Free Clinical Tools",
  "/app": "ATHENA by Vigyaved",
};

export const TitleManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    let title = MAP[pathname];
    if (!title) {
      if (pathname.startsWith("/nice/webapps/")) title = "WebApps by Vigyaved — Free Clinical Tools";
      else if (pathname.startsWith("/investigators/")) title = "Investigator Profile — Vigyaved Healthcare";
      else if (pathname.startsWith("/admin")) title = "Admin — Vigyaved Healthcare";
      else title = SUFFIX;
    }
    document.title = title;
  }, [pathname]);
  return null;
};
